// UBUB - product-form.js (version sûre & minimale)
// Fonctionne avec <product-form> OU si le form est dans la section.
// Ajoute au panier via /cart/add.js puis redirige vers /cart.

(() => {
  function wireUpForm(formEl) {
    if (!formEl || formEl.__ububWired) return;
    formEl.__ububWired = true;

    const submitBtn = formEl.querySelector('button[type="submit"], [type="submit"]');

    formEl.addEventListener('submit', (evt) => {
      evt.preventDefault();

      // Sécurise l'état du bouton
      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('loading');
        // surtout pas "disabled" => certains thèmes le stylent en noir + inactif
      }

      const formData = new FormData(formEl);

      // Vérifie qu'on poste bien un variant id
      const variantId = formData.get('id');
      if (!variantId) {
        console.error('[UBUB] Aucun "id" de variante dans le formulaire.');
        if (submitBtn) {
          submitBtn.removeAttribute('aria-disabled');
          submitBtn.classList.remove('loading');
        }
        alert("Impossible d’ajouter au panier : aucune variante sélectionnée.");
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      })
        .then(async (res) => {
          if (!res.ok) {
            let err;
            try { err = await res.json(); } catch(_) {}
            throw err || { description: 'Erreur inconnue lors de l’ajout au panier.' };
          }
          return res.json();
        })
        .then(() => {
          // Redirection sûre vers la page panier
          window.location.href = '/cart';
        })
        .catch((err) => {
          console.error('[UBUB] Add to cart error:', err);
          const msg = err && err.description ? err.description : "Impossible d’ajouter au panier.";
          alert(msg);
        })
        .finally(() => {
          if (submitBtn) {
            submitBtn.removeAttribute('aria-disabled');
            submitBtn.classList.remove('loading');
          }
        });
    });
  }

  // 1) Cas Ride/Dawn : <product-form> custom element
  if (!customElements.get('product-form')) {
    customElements.define('product-form', class extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('form');
        wireUpForm(form);
      }
    });
  } else {
    // Si le custom element existe déjà, on “rewire” quand même son form interne
    const upgrade = () => {
      document.querySelectorAll('product-form form').forEach(wireUpForm);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', upgrade);
    } else {
      upgrade();
    }
  }

  // 2) Filet de sécurité : si le thème n’utilise pas <product-form>,
  // on accroche le 1er form de la fiche produit contenant un input name="id".
  const fallback = () => {
    document.querySelectorAll('form').forEach((f) => {
      if (f.querySelector('input[name="id"]')) wireUpForm(f);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fallback);
  } else {
    fallback();
  }
})();